<template>
    <div>
        <form @submit.prevent="onSubmit">
            <div class="title-container" v-bind:style="{ background: '#FDB714' }">
                <h2 class="search-title">{{ searchboxheadlinerebooking[getCurrentLocale] }}</h2>
                <p>{{ searchboxheadlineflights2[getCurrentLocale] }}</p>
                <i class="soap-icon-search"></i>
            </div>

            <section id="content" style="padding-top: 20px; background-color: #fff;">
                <div id="main">
                    <div class="contact-address block" style="margin-left: 20px; margin-right: 20px;">
                        <h4>{{ hellotext1[getCurrentLocale] }}</h4>
                        <p v-html="hellotext2[getCurrentLocale]"></p>
                        <p v-html="hellotext3[getCurrentLocale]"></p>

                        <hr>

                        <h5 class="title">{{ when[getCurrentLocale] }}</h5>
                        <div class="row">
                            <div class="col-xs-6">
                                <label>{{ form_bookingno[getCurrentLocale] }}:* <small></small></label>
                                <input type="text" class="input-text full-width"
                                    :class="{ invalid : $v.input_bookingno.$error }"
                                    @input="$v.input_bookingno.$touch()"
                                    v-model="input_bookingno"
                                    id="'input_bookingno"
                                    name="input_bookingno" value="" placeholder="E.G.: MB4K2VUH" style="text-transform: uppercase;" />
                                <!-- >>> 'errormsg', bookingno -->
                                <p class="errormsg" v-if="$v.input_bookingno.$dirty && !$v.input_bookingno.required">{{ errmsg_required[getCurrentLocale] }}</p>
                                <p class="errormsg" v-if="$v.input_bookingno.$dirty && !$v.input_bookingno.minLength">{{ errmsg_min_bookingno[getCurrentLocale] }}</p>
                                <p class="errormsg" v-if="$v.input_bookingno.$dirty && !$v.input_bookingno.maxLength">{{ errmsg_max_bookingno[getCurrentLocale] }}</p>
                                <p class="errormsg" v-if="$v.input_bookingno.$dirty && !$v.input_bookingno.lettersandnumbers">{{ errmsg_lettersandnumbers[getCurrentLocale] }}</p>
                                <!-- <<< 'errormsg', bookingno -->
                            </div>

                            <div class="col-xs-6">
                                <label>{{ form_birthdate[getCurrentLocale] }}:* <small></small></label>
                                <input type="text" class="input-text full-width"
                                    :class="{ invalid : $v.input_birthdate.$error }"
                                    @input="$v.input_birthdate.$touch()"
                                    v-model="input_birthdate"
                                    id="'input_birthdate"
                                    name="input_birthdate" value="" placeholder="E.G.: 01.01.1984" />
                                <!-- >>> 'errormsg', input_birthdate -->
                                <p class="errormsg" v-if="$v.input_birthdate.$dirty && !$v.input_birthdate.required">{{ errmsg_required[getCurrentLocale] }}</p>
                                <p class="errormsg" v-if="$v.input_birthdate.$dirty && !$v.input_birthdate.minLength">{{ errmsg_min_birthdate[getCurrentLocale] }}</p>
                                <p class="errormsg" v-if="$v.input_birthdate.$dirty && !$v.input_birthdate.maxLength">{{ errmsg_max_birthdate[getCurrentLocale] }}</p>
                                <!-- <<< 'errormsg', input_birthdate -->
                            </div>
                        </div>

                        <br />

                        <p-check class="p-svg p-round p-pulse" color="success" value="ABB" v-model="checkedBoxes">
                            <svg slot="extra" class="svg svg-icon" viewBox="0 0 20 20">
                                <path d="M7.629,14.566c0.125,0.125,0.291,0.188,0.456,0.188c0.164,0,0.329-0.062,0.456-0.188l8.219-8.221c0.252-0.252,0.252-0.659,0-0.911c-0.252-0.252-0.659-0.252-0.911,0l-7.764,7.763L4.152,9.267c-0.252-0.251-0.66-0.251-0.911,0c-0.252,0.252-0.252,0.66,0,0.911L7.629,14.566z" style="stroke: white;fill:white" />
                            </svg>
                        </p-check>
                        <span class="skin-color" style="font-size: 1.0833em;" >{{ checkboxtext[getCurrentLocale] }}</span>

                        <hr>

                        <!-- >>> Submit -->
                        <a class="button btn-large uppercase full-width silver" v-if="!checkValidity() && get_FlagRebookingBookingnoLoginIsReadyForLogin === false">{{ getbookinno[getCurrentLocale] }}</a>
                        <button type="submit" class="btn-large icon-check-rebooking uppercase full-width" v-if="checkValidity() && get_FlagRebookingBookingnoLoginIsReadyForLogin === true" v-bind:class="{ sundairsrvcs: modulo === 'services', 'icon-check3': modulo === 'services' }"  v-bind:style="{ background: '#FDB714' }">{{ getbookinno[getCurrentLocale] }}</button>
                    </div>
                </div>
            </section>
        </form>
    </div>
</template>

<script>
    import { helpers, required, minLength, maxLength, numeric, alphaNum, email } from 'vuelidate/lib/validators';
    const letterspaces = helpers.regex('letterspaces', /^[a-z-öÖüÜäÄ\s]+$/i); /* Validator */
    const numericspaces = helpers.regex('numericspaces', /^[0-9+/\s]+$/i); /* Validator */
    const lettersandnumbers = helpers.regex('lettersandnumbers', /^[A-Za-z0-9]+$/i); /* Validator */

    import { mapGetters } from 'vuex';
    import { mapActions } from 'vuex';

    import axios from 'axios';
    import moment from 'moment';
    import { eventBus } from '../../../main';


    export default {

        /* >>> *************************************************************** /  /* Data */
        data: function() {

            return {
                searchboxheadlinerebooking: {
                    en: 'Find booking and rebook flights',
                    de: 'Buchung finden und Flüge umbuchen',
                },
                searchboxheadlineflights2: {
                    en: 'Discover the world with SUNDAIR!',
                    de: 'Entdecke die Welt mit SUNDAIR!',
                },
                hellotext1 : {
                    en: 'Rebook your flights',
                    de: 'Buchen Sie Ihre Flüge um',
                },
                hellotext2 : {
                    en: 'Here you can rebook your already booked flight comfortably and easily until 48 hours before departure. Please enter your booking number and your date of birth.',
                    de: 'Hier können Sie Ihren bereits gebuchten Flug bequem und einfach bis 48 Stunden vor Abflug umbuchen. Bitte geben Sie dafür Ihre Buchungsnummer und Ihr Geburtsdatum ein.',
                },
                hellotext3 : {
                    en: 'Note: A rebooking is only possible if you have booked the flights directly with SUNDAIR. If you have booked with us but through a tour operator, please contact your tour operator.',
                    de: '<b>Hinweis</b>: Eine Umbuchung ist nur möglich, wenn Sie die Flüge direkt bei SUNDAIR gebucht haben. Sollten Sie mit uns fliegen, aber über einen Reiseveranstalter gebucht haben, wenden Sie sich bitte an Ihren Reiseveranstalter.',
                },
                checkboxtext : {
                    en: 'I hereby confirm that I am authorised to manage this booking on behalf of other passengers or if I am the only passenger',
                    de: 'Hiermit bestätige ich, dass ich berechtigt bin, diese Buchung im Namen anderer Passagiere zu verwalten oder wenn ich der einzige Passagier bin.',
                },
                // ----------------------------------
                when: {
                    en: 'Your booking data',
                    de: 'Ihre Buchungsdaten',
                },
                form_bookingno: {
                    en: 'Your bookingcode',
                    de: 'Ihr Buchungscode',
                },
                form_birthdate: {
                    en: 'Your birthdate',
                    de: 'Ihr Geburtsdatum',
                },
                // ----------------------------------
                getbookinno: {
                    en: 'REBOOK YOUR FLIGHTS',
                    de: 'IHRE FLÜGE UMBUCHEN',
                },
                // >>> --------------------------
                checkedBoxes: [],
                // >>> --------------------------
                // input_bookingno: 'JTGQJG23',
                // input_birthdate: moment('01.01.2000', "DD.MM.YYYY").format('DD.MM.YYYY'),
                input_bookingno: '',
                input_birthdate: '',
                // >>> --------------------------
                errmsg_required: {
                    en: 'This Field must not be empty.',
                    de: 'Dieses Feld darf nicht leer sein.',
                },
                // >>> --------------------------
                errmsg_letterspaces: {
                    en: 'Letters, "-" and spaces are allowed.',
                    de: 'Erlaubt sind Buchstaben, “-“ und Leerzeichen.',
                },
                errmsg_lettersandnumbers: {
                    en: 'Letters and Numberss are allowed.',
                    de: 'Erlaubt sind Buchstaben und Zahlen.',
                },
                // >>> --------------------------
                errmsg_min_bookingno: {
                    en: 'Allowed length: 6-12 characters.',
                    de: 'Erlaubte Länge: 6-12 Zeichen.',
                },
                errmsg_max_bookingno: {
                    en: 'Allowed length: 6-12 characters.',
                    de: 'Erlaubte Länge: 6-12 Zeichen.',
                },
                errmsg_min_birthdate: {
                    en: 'Allowed length: 10 characters.',
                    de: 'Erlaubte Länge: 10 Zeichen.',
                },
                errmsg_max_birthdate: {
                    en: 'Allowed length: 10 characters.',
                    de: 'Erlaubte Länge: 10 Zeichen.',
                },
                // >>> --------------------------
                // currentLocale: 'de',
            };

        }, // eo data
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Validations */
        validations: {

            input_bookingno: {
                required: required,
                minLength: minLength(6),
                maxLength: maxLength(12),
                lettersandnumbers: lettersandnumbers
            },
            input_birthdate: {
                required: required,
                minLength: minLength(10),
                maxLength: maxLength(10),
            },

        }, // eo validations
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'getCurrentLocale',
                'get_FlagRebookingBookingnoLoginIsReadyForLogin',
            ]),

        }, // eo computed
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Watch */
        watch: {

            checkedBoxes: function() {

                if (this.checkedBoxes.length === 1)  {
                    this.actn_FlagRebookingBookingnoLoginIsReadyForLogin(true);
                } else {
                    this.actn_FlagRebookingBookingnoLoginIsReadyForLogin(false);
                }

            } // eo function checkedBoxes()

        }, // eo watch
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc:
        * Note: Catch Event 'readytoshowbookingforrebooking'.
        *
        */
		created: function () {

            let me = this;


            me.$toc('>>> shared/forms/BookingnoTab.vue >>> created');
            me.actn_set_stateReset();
            eventBus.$on('readytoshowbookingforrebooking', this.onEmit_ReadyToShowBookingForRebooking);

        }, // eo function created()


        /***********************************************************************
        * Lifecyclehook::mounted
        *
        * Desc:
        * Note:
        *
        */
		mounted: function () {

            var me = this;


        }, // eo function mounted()


        /***********************************************************************
        * Lifecyclehook::beforeDestroy
        *
        * Desc: Destroy Listener.
        * Note:
        *
        */
        beforeDestroy: function() {

            let me = this;


            me.$toc('>>> shared/forms/BookingnoTab.vue >>> beforeDestroy');
            eventBus.$off('readytoshowbookingforrebooking', this.onEmit_ReadyToShowBookingForRebooking);

        }, // eo function beforeDestroy()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

            ...mapActions([
                'actn_FlagRebookingBookingnoLoginIsReadyForLogin',  // Control Flag
                'actn_set_stateReset',
                'actn_FlagSharedShowFlightSearchResults',           // Control Flag (Hide 'Section')
                'actn_FlagRebookingShowBookingnoSearchResults',     // Control Flag (Hide 'Section')
                'actn_setRebookingUsersSearchDataBookingno',        // remember in state
                'actn_call_rebookingGetBooking',                    // Call:
            ]),


            /******************************************************************* 'Listeners - Common'
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * onSubmit()
            *
            * Desc: 'Bookingno Rebooking Form' gets (not really) submitted.
            * Note:
            *
            * @param {Object} submitEvent (Event)
            * @return
            */
            onSubmit: function(submitEvent) {

                let me = this,
                    input_birthdate = submitEvent.target.elements.input_birthdate.value.split('.'),
                    myBookingnoParams = {};


                me.$toc('>>> shared/forms/BookingnoTab.vue >>> onSubmit');
                myBookingnoParams.bookingCode = this.input_bookingno.toUpperCase();
                myBookingnoParams.paxBirthDate = moment(input_birthdate[2] + '-' + input_birthdate[1] + '-' + input_birthdate[0]).format('YYYY-MM-DDT00:00:ss+0000'); // this.input_birthdate.toUpperCase(); // 1994-01-01T12:20:00
                myBookingnoParams.email = null;
                myBookingnoParams.idCarrier = null;
                myBookingnoParams.idInvoice= null;
                myBookingnoParams.justIdInvoice = false;
                myBookingnoParams.lastName = null;
                myBookingnoParams.modify= false;
                myBookingnoParams.operatorBooking = null;

                me.actn_FlagSharedShowFlightSearchResults(false);                   // Hide 'Section'
                me.actn_FlagRebookingShowBookingnoSearchResults(false);             // Hide 'Section'
                this.actn_setRebookingUsersSearchDataBookingno(myBookingnoParams);  // remember in state

                this.actn_call_rebookingGetBooking(myBookingnoParams);

            }, // eo function onSubmit()


            /******************************************************************* 'Listeners - eventBus'
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * onEmit_ReadyToShowBookingForRebooking()
            *
            * Desc:
            * Note:
            *
            */
            onEmit_ReadyToShowBookingForRebooking: function() {

                let me = this,
                    options = {};



                me.$toc('>>> shared/forms/BookingnoTab.vue >>> onEmit_ReadyToShowOriginalBooking');
                // >>> Scroll Options ------------------------------------------
                options = {
                    container: 'body',
                    easing: 'linear',
                    offset: -60,
                    force: true,
                    cancelable: true,
                    onStart: function(element) {
                        // scrolling started
                    },
                    onDone: function(element) {
                        // scrolling is done
                    },
                    onCancel: function() {
                        // scrolling has been interrupted
                    },
                    x: false,
                    y: true
                };

                // >>> Showing/Scrolliing --------------------------------------
                me.actn_FlagRebookingShowBookingnoSearchResults(true);          // Show 'Section'
                setTimeout(function() {
                    me.$scrollTo('#contentElementRebookingBookingno', 200, options);
                }, 300);

            }, // eo function onEmit_ReadyToShowBookingForRebooking()



            /*******************************************************************
            * Utilities:
            *******************************************************************/
            /*******************************************************************
            * checkValidity()
            *
            * Desc:
            * Note:
            *
            * @param
            * @return {Array}
            */
            checkValidity: function() {

                var me = this,
                    formIsValid = false;


                me.$toc('>>> shared/forms/BookingnoTab.vue >>> checkValidity');
                // Last Check: Inputs ---------------------
                if (this.input_bookingno !== '') {
                    if (!me.$v.input_bookingno.$error) {
                        formIsValid = true;
                    } else {
                        formIsValid = false;
                    }
                } else {
                    formIsValid = false;
                }

                if (formIsValid === true) {
                    if (this.input_birthdate !== '') {
                        if (!me.$v.input_birthdate.$error) {
                            formIsValid = true;
                        } else {
                            formIsValid = false;
                        }
                    } else {
                        formIsValid = false;
                    }
                }



                // Last Check: Checkbox -------------------
                if (formIsValid === true) {
                    if (this.get_FlagRebookingBookingnoLoginIsReadyForLogin === true) {
                        formIsValid = true;
                    } else {
                        formIsValid = false;
                    }
                }


                return formIsValid;

            }, // eo function checkValidity()

        }, // eo methods
        /* <<< ****************************************************************/

    };
</script>

<style scoped>
    .icon-check-rebooking {
        position: relative;
        padding-right: 30px !important;
        padding-left: 0 !important;
        overflow: hidden;
    }
    .icon-check-rebooking:after {
        content: "";
        position: absolute;
        top: 0;
        right: 0;
        width: 30px;
        height: 100%;
        background: url(/res/images/icon/icon-check.png) no-repeat center center #FDB714;
    }

    .errormsg {
        margin-bottom: 3px;
        margin-top: 3px;
        color: red;
    }
</style>